import * as Sentry from '@sentry/react'
import { ShareIcon } from 'lucide-react'
import { FixedMobileTopBar, NavigateBack } from '@/components/ui/FixedMobileTopBar'
import { WatchHeartButton } from '@/features/accommodation/watch-heart/WatchHeartButton'
import { shareAccommodation } from './shareAccommodation'

interface AccommodationDetailFixedTopBarProps {
  name: string
  slug: string
  unitId: number
}

export function AccommodationDetailFixedTopBar({ name, slug, unitId }: AccommodationDetailFixedTopBarProps) {
  return (
    <FixedMobileTopBar
      left={<NavigateBack />}
      right={
        <div className="flex items-center gap-2">
          <WatchHeartButton slug={slug} unitId={unitId} source="detail" variant="pill" />
          <button
            aria-label="Sdílet"
            onClick={() => {
              shareAccommodation(name).catch((error: unknown) => {
                Sentry.captureException(error)
              })
            }}
            className="flex h-10 items-center gap-1.5 rounded-full bg-white/70 pr-4 pl-3 backdrop-blur-sm"
          >
            <ShareIcon className="h-5 w-5 text-slate-700" />
            <span className="text-sm font-medium text-slate-700">Sdílet</span>
          </button>
        </div>
      }
    />
  )
}
